import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { WardsService } from 'src/app/services/wards-service/wards.service';
import { switchMap } from 'rxjs/operators';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { PreviousQuestionPaperService } from '../../services/previous-question-paper.service';
import { PreviousQuestionPaper } from '../../models/previous-question-paper';

@Component({
  selector: 'app-previous-question-paper',
  templateUrl: './previous-question-paper.component.html',
  styleUrls: ['./previous-question-paper.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class PreviousQuestionPaperComponent implements OnInit {

  constructor(private pageHeadingService: PageHeadingService,
    private wardsService: WardsService,
    private previousQuestionPapersService: PreviousQuestionPaperService,
    private routingService: RoutingService,
    private renderer: Renderer2) { }

    public config: PerfectScrollbarConfigInterface = {};
    questionPapers: Array<Array<PreviousQuestionPaper>>;
    loading: boolean = true;
    selectedSubject: Array<PreviousQuestionPaper>;
  
    ngOnInit() {
      this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Question papers"));
  
      this.wardsService.ward$.pipe(
        switchMap(ward => {
          return this.previousQuestionPapersService.getAllSharedQuestionPapers(ward.student_id);
        })
      ).subscribe((res) => {
        this.loading = false;
        this.questionPapers = res;
        this.selectedSubject = this.questionPapers[0];
        let route = new PrifactRoute();
        route.primary_command = ['pages', 'previous-question-papers', this.questionPapers[0][0].subject_id]
        this.routingService.navigate(route);
      })
    }
  
    subjectClicked(subject: Array<PreviousQuestionPaper>) {
      this.selectedSubject = subject;
      let route = new PrifactRoute();
      route.primary_command = ['pages', 'previous-question-papers', subject[0].subject_id];
      route.append_current_url_to_history = true;
      this.routingService.navigate(route);
      this.renderer.addClass(document.body, 'second-page');
    }

}
